
import.meta.glob('../images/**/*.{png,jpg,jpeg,svg,webp}', { eager: true });
import { modal } from './utils/modal';
import { accordion } from './utils/accordion';
import { FVRive } from './utils/fv-rive';
import { headerScroll } from './utils/header-scroll';
import { smoothScroll } from './utils/smooth-scroll';
import { telLinks } from './utils/tel-links';
import { recruitTabs } from './utils/recruit-tabs';
import { odometerInNumbers } from './utils/odometer-in-numbers';
import { scrollAnimation } from './utils/scroll-animation';
import { smfFormButton } from './utils/smf-form-button';
import { smfEmailConfirm } from './utils/smf-email-confirm';
import { smfPrivacyCheckbox } from './utils/smf-privacy-checkbox';
import { initLowerFvHeadingDebug } from './utils/lower-fv-heading-debug';

type IdleCallback = (cb: () => void) => void;

const scheduleIdle: IdleCallback = (cb) => {
  const w = window as Window & {
    requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
  };
  if (typeof w.requestIdleCallback === 'function') {
    w.requestIdleCallback(cb, { timeout: 1000 });
  } else {
    window.setTimeout(cb, 200);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  console.log('WordPress + Vite is working!');
  modal.init();
  accordion.init();
  headerScroll.init();
  smoothScroll.init();
  telLinks.init();
  recruitTabs.init();
  odometerInNumbers.init();
  new FVRive();
  smfFormButton();
  smfEmailConfirm();
  smfPrivacyCheckbox();
  initLowerFvHeadingDebug();
});

// GSAP/ScrollTrigger を使うスクロールアニメは初期描画を遅らせるため、
// load 後のアイドル時間に初期化する
window.addEventListener('load', () => {
  scheduleIdle(() => {
    scrollAnimation.init();
  });
});
